
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenTask } from './GenTask';
import { GenUser } from './GenUser';

export class GenBulkUploadRequest {

    contributor: GenUser;
    initialTags: string[];
    itemsToPrepareForUpload: GenTask[];
    namePrefix: string;
    releaseNotes: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genBulkUploadRequest: GenBulkUploadRequest);

    constructor( input?: GenBulkUploadRequest ) {
        if ( input && typeof input !== 'number' ) {
            if( input.contributor ) {
              this.contributor = new GenUser( input.contributor );
            }
            this.initialTags = input.initialTags; // list [string]
            if ( input.itemsToPrepareForUpload && input.itemsToPrepareForUpload.map ) { // list [GenTask]
                this.itemsToPrepareForUpload = input.itemsToPrepareForUpload.map( ( x: GenTask ) => {
                    return new GenTask( x );
                } );
            } else {
                this.itemsToPrepareForUpload = input.itemsToPrepareForUpload;
            }
            this.namePrefix = input.namePrefix; // string [string]
            this.releaseNotes = input.releaseNotes; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenBulkUploadRequest[] {
        if (arr && arr.map) {
          return arr.map(a => new GenBulkUploadRequest(a));
        } else {
          return [];
        }
    }
}

